<template>
    <v-dialog
            v-model="dialogState"
            :width="width"
    >
      <v-card>
          <v-toolbar
                  dark
                  color="primary"
          >
              <v-toolbar-title>Создание пространства</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                  <v-btn
                          icon
                          dark
                          @click="dialogState = false"
                  >
                      <v-icon>mdi-close</v-icon>
                  </v-btn>
              </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
              <v-container>
                  <v-row>
                      <v-col>
                          <work-space-create @created="onCreatedWorkSpace"></work-space-create>
                      </v-col>
                  </v-row>
              </v-container>
          </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>
import WorkSpaceCreate from "./WorkSpaceCreate.vue";
import {mapActions, mapGetters} from "vuex";

export default {
    name: "WorkSpaceCreateModal",
    components: {WorkSpaceCreate},
    data() {
        return {
        }
    },
    methods: {
        ...mapActions('workspace', ['CHECKOUT']),
        ...mapActions('dialog', {dialogToggle: 'toggle'}),
        onCreatedWorkSpace(data){
            this.dialogToggle();
            this.CHECKOUT(data.id);
        }
    },
    computed:{
        dialogState: {
            get() {
                return this.dialog && this.name === 'WorkSpaceCreateModal'
            },
            set() {
                this.dialogToggle();
            }
        },
        ...mapGetters('dialog', ['dialog', 'width', 'name']),
    }
}
</script>

<style scoped>

</style>